<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Chamados</h3>
        <d-link class="btn btn-success text-white float-right " :to="{name: 'admin-ticket-new'}">Novo chamado</d-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Chamados Ativos</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <ticket-client-table :tickets="tickets.list" v-if="isCustomer"/>
              <ticket-table :tickets="tickets.list" v-else/>
            </div>
            <pagination :total-items="tickets.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import TicketTable from '../components/TicketListTable.vue';
import TicketClientTable from '../components/TicketClientListTable.vue';

export default {
  name: 'ticket-list',
  components: {
    Pagination,
    TicketTable,
    TicketClientTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    tickets() {
      const { ticketList } = this.$store.state.ticket;
      if (ticketList && ticketList.list.length) {
        return ticketList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id !== 3 || !user.settings.customer_id) {
        return false;
      }
      return true;
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getTicketList',
    ]),
    getList() {
      this.getTicketList(this.pagination);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
